export enum ChannelType {
    system = 0,
    webEvents = 1,
    actionPlans = 2,
    ePlans = 3,
    listingEvents = 4,
    callEvents = 5,
    facebookEvents = 6,
    gmailEvents = 7,
    messageEvents = 8,
    formRequests = 9,
    externalRequests = 10,
    webPushEvents = 11,
}
